import { ERC20 } from "../abi/ERC20";
import { web3Instance } from "../factory";

export const getTokenAllowance = (
  chainId: number,
  account: string,
  tokenAddress: string,
  spenderAddress: string
): Promise<string> => {
  if (!chainId) console.warn("No chainId provided. Using BSC [56] as default");
  if (!account || !tokenAddress || !spenderAddress) {
    console.warn("No account or token adddress provided.");
    return Promise.resolve("0");
  }

  const web3 = web3Instance.getInstance(chainId);
  const contract = new web3.eth.Contract(ERC20, tokenAddress);

  return contract.methods.allowance(account, spenderAddress).call();
};
